import TeamList from "../../Employee-teams/Teams-list";

import { Modal, Grid, Typography, IconButton } from "@mui/material";

import { ClearOutlined as ClearOutlinedIcon } from "@mui/icons-material";

import ContainerCard from "../../../../../components/Cards/ContainerCard";

import { useTranslation } from "react-i18next";

const TeamTable = ({
  display = false,
  setDisplay = () => {},
  tenant = null,
  handleClick = () => {},
  initialVal = [],
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={display}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <ContainerCard sx={{ padding: "10px 20px", width: "50%", minHeight: "97vh" }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontFamily: "poppins",
              }}
            >
              {t("teamTable.AddTeam")}
            </Typography>
            <IconButton onClick={() => setDisplay(false)}>
              <ClearOutlinedIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TeamList
              fromEmployee
              initialVal={initialVal}
              tenant={tenant}
              handleClick={handleClick}
            />
          </Grid>
        </Grid>
      </ContainerCard>
    </Modal>
  );
};

export default TeamTable;
